import { storage } from "@/lib/appwrite";

export function getUserAvatarUrl(user?: { prefs?: { avatar?: string } }) {
    const bucketId = import.meta.env.VITE_BUCKET_ID_AVATAR_COLLABORATOR!;
    const avatarFileId = (user?.prefs as any)?.avatar;

    return avatarFileId
        ? storage.getFilePreview(bucketId, avatarFileId, 100, 100)
        : "/images/perfil.png";
}


const bucketId = import.meta.env.VITE_BUCKET_ID_AVATAR_COLLABORATOR!;

export async function getAllAvatarUrl(userId?: string): Promise<string> {
  if (!userId) return "/images/perfil.png";

  try {
    await storage.getFile(bucketId, userId); // verificar si existe
    return storage.getFilePreview(bucketId, userId, 100, 100);
  } catch (err) {
    return "/images/perfil.png"; // fallback si no existe
  }
}